import { Button, Card, Flex, Group, Modal, Stack, Text, Textarea, ThemeIcon } from "@mantine/core"
import { WarningCircleIcon } from "@phosphor-icons/react"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { ConfirmNote } from "@dehub/theme"

type Props = {
  opened: boolean
  onClose: () => void
  onConfirm: (reason: string) => void
  loading?: boolean
  orderCode: string
  deliveryNoteCount: number
  invoiceCodes: string[]
  helpNs?: string
}

export function CancelConfirmedOrderModal ({
  opened,
  onClose,
  onConfirm,
  loading = false,
  orderCode,
  deliveryNoteCount,
  invoiceCodes,
  helpNs = "order.supplier-sales-detail"
}: Props) {
  const { t } = useTranslation(["supplierSales", "common"])
  const [reason, setReason] = useState("")
  const trimmed = reason.trim()

  const handleClose = () => {
    setReason("")
    onClose()
  }

  const invoiceLabel = invoiceCodes.length > 0
    ? invoiceCodes.join(", ")
    : "—"

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title={t("supplierSales:cancelConfirmed.title")}
      centered
      radius="lg"
    >
      <Stack gap="md">
        <Card withBorder padding="md" radius="md">
          <Group align="flex-start" gap="sm" wrap="nowrap">
            <ThemeIcon color="gray" variant="light" size="lg" radius="md">
              <WarningCircleIcon size={20} />
            </ThemeIcon>
            <Stack gap={4}>
              <Text fw={600} size="sm">{orderCode}</Text>
              <Text size="sm" c="dimmed">
                {t("supplierSales:cancelConfirmed.summaryDn", { count: deliveryNoteCount })}
                {" · "}
                {t("supplierSales:cancelConfirmed.summaryStock")}
                {" · "}
                {t("supplierSales:cancelConfirmed.summaryInvoice", { codes: invoiceLabel })}
              </Text>
            </Stack>
          </Group>
        </Card>

        {/* «Дараа нь юу болох» (spec 10 §2.11c) */}
        <ConfirmNote helpKey={`${helpNs}.confirm.cancel`} mt={0} />

        <Textarea
          label={t("supplierSales:cancelConfirmed.reasonLabel")}
          placeholder={t("supplierSales:cancelConfirmed.reasonPlaceholder")}
          value={reason}
          onChange={(e) => setReason(e.currentTarget.value)}
          maxLength={500}
          autosize
          minRows={3}
          maxRows={6}
          required
        />

        <Flex justify="flex-end" gap="sm">
          <Button variant="default" onClick={handleClose} disabled={loading}>
            {t("common:actions.dismiss")}
          </Button>
          <Button
            onClick={() => onConfirm(trimmed)}
            loading={loading}
            disabled={!trimmed}
          >
            {t("supplierSales:cancelConfirmed.confirm")}
          </Button>
        </Flex>
      </Stack>
    </Modal>
  )
}
